import { Column, Entity, PrimaryGeneratedColumn, ManyToOne } from 'typeorm';
import CfgEDsys from '../types/CfgEDsys';
import Cardapio from './Cardapio';

@Entity()
export class Empresa {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  nome: string = '';

  @Column()
  endereco: string = '';

  @Column()
  telefone: string = '';

  @Column()
  horarioFuncionamento: string = '';

  @Column()
  aberto: boolean = false;

  @Column()
  precoDelivery: number = 10;

  @Column()
  tempoDelivery: number = 90;

  @Column()
  tempoBalcao: number = 90;

  @Column()
  pedidoMinimo: number = 10;

  @Column()
  valorMinimoDeliveryGratis?: number;

  @Column()
  verificaClientes: boolean = false;

  @Column()
  cnpj: string = '';

  @Column()
  imprimeCNPJ: boolean = false;

  @Column()
  usaComandas: boolean = false;

  @Column()
  aceitaEnderecoSemCEP: boolean = false;

  @Column()
  utilizaEDPrinter: boolean = false;

  @Column()
  urlEDPrinter: string = '';

  @Column()
  impressoraEDPrinter: string = '';

  @Column()
  aceitarDiretoAdmin: boolean = false; // aceita pedidos feitos por algum admin direto

  @Column()
  qntViaCliente: number = 1;

  @Column()
  qntViaEntregador: number = 0;

  @Column({ select: false })
  senhaGerente: string = '';

  @Column()
  esconderModalBaixarApp: boolean = false;

  @Column({ type: 'json' })
  cfgEDsys?: CfgEDsys;

  @Column()
  quantidadePedidos?: number = 0;

  @Column()
  ultimoUpdatePedido?: Date;

  @ManyToOne(() => Cardapio, { eager: true })
  cardapio!: Cardapio;
}

export default Empresa;
